module.exports = __webpack_public_path__ + "img/searching.849aadfd.svg";